import React from 'react';
import './FreightTable.css';
import {PublicApiConsignmentFreightResponse} from "../Representation";

interface FreightTableProps {
    freight?: PublicApiConsignmentFreightResponse[] | null
}

const FreightTable = (
    props: FreightTableProps
) => {

    const freight = props.freight || [];

    return (
        <div className="FreightTable">
            <table>
                <thead>
                <tr>
                    <th>Freight</th>
                    <th>Quantity</th>
                </tr>
                </thead>
                <tbody>
                {freight.map((row, index) => {
                    const qty = row.netQuantity || row.orderedQuantity;
                    return (
                        <tr key={"row_" + index}>
                            <td>{row.description}</td>
                            <td>{qty} <span className="ConsignmentFreight-uom">{ row.unitOfMeasureDescription }</span></td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    )

}

export default FreightTable;
